import { render } from "./IconFile.vue?vue&type=template&id=2f34200e"
import script from "./IconFile.vue?vue&type=script&lang=ts"
export * from "./IconFile.vue?vue&type=script&lang=ts"
script.render = render

export default script